import {
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    FORMATTED_SUBCATEGORY_MAP,
    SEASONAL_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { ArrowRightChunky, HolidayCalendar } from '@eventbrite/eds-iconography';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { STATSIG_EVENT_NAMES } from '../../constants';
import './NYETouchpoint.scss';

const ctaLink = `/b/local/${EVENTBRITE_CATEGORY_TO_REFINEMENT[SEASONAL_EVENTBRITE_CATEGORY]}/${FORMATTED_SUBCATEGORY_MAP['EventbriteSubCategory/16009'].refinement}/?utm_source=listing_nye_touchpoint_click`;

export const NYETouchpoint = ({ isMobile }: { isMobile: boolean }) => {
    const handleOnClick = () => {
        logEvent(STATSIG_EVENT_NAMES.LISTING_NYE_TOUCHPOINT_CLICK);
    };

    return (
        <div className="nye-touchpoint" data-testid={'nye_touchpoint'}>
            <a
                href={ctaLink}
                onClick={handleOnClick}
                className="nye-touchpoint-wrapper"
                data-heap-id="nye_touchpoint"
            >
                <div className="eclipse">
                    <div>
                        <HolidayCalendar
                            viewBox="0 0 32 32"
                            className="calendar"
                        />
                    </div>
                </div>
                {isMobile ? (
                    <span className="nye-touchpoint-text">
                        Explore more holiday festivities near you
                    </span>
                ) : (
                    <span className="nye-touchpoint-text">
                        Explore New Year’s Eve events near you
                    </span>
                )}
                <ArrowRightChunky className="arrow-right" />
            </a>
        </div>
    );
};
